import {AbstractControl, ValidatorFn} from '@angular/forms';
import {DetailControlOption} from '../../detail-tabconfig';

export function optioncontrolRequired(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    if (
      control.value == null ||
      control.value === '' ||
      control.value === DetailControlOption.NullValueOverwrite
    ) {
      return {required: {value: null}};
    } else {
      return null;
    }
  };
}
